import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const retrieve = ({ commit }, id) => {
  commit(types.EXSBPRICEITEM_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.EXSBPRICEITEM_SHOW_TOGGLE_LOADING)
      commit(types.EXSBPRICEITEM_SHOW_SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.EXSBPRICEITEM_SHOW_TOGGLE_LOADING)
      commit(types.EXSBPRICEITEM_SHOW_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.EXSBPRICEITEM_SHOW_RESET)
}
